import React, { useState, useEffect } from "react";
import { Box, Button, TextField, MenuItem, useTheme, CircularProgress } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { tokens } from "../../../theme";
import Header from "../../../components/Header";
import axios from 'axios';

const EditColaborador = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [colaboradorData, setColaboradorData] = useState({
    nome: "",
    email: "",
    cargo: "",
    valorHora: "",
    tipo: "",
    senha: "",
  });

  const [clientes, setClientes] = useState([]);
  const [tiposAcesso, setTiposAcesso] = useState(["BASICO", "ADMIN"]); // Opções de acesso padrões
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar o carregamento
  const [showPasswordFields, setShowPasswordFields] = useState(false); // Estado para controlar a visibilidade dos campos de senha

  useEffect(() => {
    const fetchColaborador = async () => {
      try {
        const response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${id}`);
        const { nome, email, cargo, valorHora, tipo, senha } = response.data;
        setColaboradorData({
          nome,
          email,
          cargo,
          valorHora,
          tipo,
          senha,
        });

        // Atualiza os tipos de acesso com a resposta da API
        setTiposAcesso(prevTipos => {
          if (!prevTipos.includes(tipo)) {
            return [...prevTipos, tipo];
          }
          return prevTipos;
        });

      } catch (error) {
        console.error("Erro ao buscar colaborador:", error);
      } finally {
        setIsLoading(false); // Desativa o carregamento
      }
    };

    const fetchClientes = async () => {
      try {
        const response = await axios.get(`https://pf-auditores.ew.r.appspot.com/api/clientes`);
        setClientes(response.data);
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
      }
    };

    fetchColaborador();
    fetchClientes();
  }, [id]);

  const handleGuardarClick = async () => {
    const confirmacao = window.confirm("Tem certeza que deseja atualizar os dados do colaborador?");
    if (confirmacao) {
      try {
        await axios.put(`https://pf-auditores.ew.r.appspot.com/api/colaboradores/${id}`, colaboradorData);
        console.log("Colaborador editado com sucesso:", colaboradorData);
        navigate("/colaboradores");
      } catch (error) {
        console.error("Erro ao editar colaborador:", error, colaboradorData);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "projetoId") {
      const clienteSelecionado = clientes.find(cliente => cliente.id === value);
      setColaboradorData({
        ...colaboradorData,
        projeto: clienteSelecionado,
        [name]: value,
      });
    } else {
      setColaboradorData({
        ...colaboradorData,
        [name]: value,
      });
    }
  };

  const handleConfirmarSenhaChange = (e) => {
    setConfirmarSenha(e.target.value);
  };

  const handleShowPasswordFields = () => {
    setShowPasswordFields(true);
  };

  if (isLoading) {
    return (
      <Box m="20px" display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Header title="Editar Colaborador" subtitle="Edite os detalhes do colaborador" />
      <form onSubmit={(e) => { e.preventDefault(); handleGuardarClick(); }}>
        <Box
          sx={{
            display: 'grid',
            gap: '20px',
            backgroundColor: colors.primary[400],
            padding: '20px',
            borderRadius: '8px',
            gridTemplateColumns: 'repeat(2, 1fr)', 
          }}
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Nome"
            name="nome"
            value={colaboradorData.nome}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            variant="filled"
            type="email"
            label="Email"
            name="email"
            value={colaboradorData.email}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Cargo"
            name="cargo"
            value={colaboradorData.cargo}
            onChange={handleChange}
          />     
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Valor Hora"
            name="valorHora"
            value={colaboradorData.valorHora}
            onChange={handleChange}
          />  
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Tipo de Acesso"
            name="tipo"
            select
            value={colaboradorData.tipo}
            onChange={handleChange}
          >
            {tiposAcesso.map((tipo) => (
              <MenuItem key={tipo} value={tipo}>
                {tipo}
              </MenuItem>
            ))}
          </TextField>
          {showPasswordFields && (
            <>
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Palavra-Passe"
                name="senha"
                value={colaboradorData.senha}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Confirmar Palavra-Passe"
                name="confirmarSenha"
                value={confirmarSenha}
                onChange={handleConfirmarSenhaChange}
              />
            </>
          )}
        </Box>
        <Box mt="20px" display="flex" justifyContent="space-between" alignItems="center">
          <Button variant="contained" color="primary" onClick={() => navigate("/colaboradores")}>
            Voltar
          </Button>
          <Box>
            <Button variant="contained" color="primary" onClick={handleShowPasswordFields} sx={{ marginRight: '10px' }}>
              Trocar Senha
            </Button>
            <Button variant="contained" color="secondary" type="submit">
              Guardar
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default EditColaborador;
